import {memo, PropTypes, propTypesExact, shapeComponent, ShapeComponent, Text, useStyles, View} from "shared/base"
import {Platform, Pressable, StyleSheet} from "react-native"
import React, {useMemo} from "react"
import AppHistory from "shared/history"
import Link from "@kaspernj/api-maker/build/link"

const styles = StyleSheet.create({
  button: {
    paddingVertical: 16,
    paddingHorizontal: 3,
    borderBottomColor: "#b7b8ff",
    borderBottomWidth: 2
  },
  buttonPrimary: {
    borderBottomColor: "#2c2c96"
  },
  text: {
    color: "#b7b8ff",
    fontSize: 16,
    fontWeight: "bold",
    textAlign: "center"
  },
  textPrimary: {
    color: "#2c2c96"
  }
})

/**
 * @typedef {object} ChalkyLayoutButtonUnderscoreProps
 * @property {unknown} dataSet
 * @property {boolean} disabled
 * @property {unknown} onPress
 * @property {boolean} primary
 * @property {unknown} style
 * @property {unknown} testID
 * @property {unknown} title
 * @property {unknown} to
 */

/** @typedef {object} ChalkyLayoutButtonUnderscoreState */

/**
 * @extends {ShapeComponent<ChalkyLayoutButtonUnderscoreProps, ChalkyLayoutButtonUnderscoreState>}
 */
class ChalkyLayoutButtonUnderscore extends ShapeComponent {
  static defaultProps = {
    dataSet: undefined,
    disabled: false,
    onPress: null,
    primary: false,
    style: null,
    testID: null,
    to: null
  }

  static propTypes = propTypesExact({
    dataSet: PropTypes.object,
    disabled: PropTypes.bool.isRequired,
    onPress: PropTypes.func,
    primary: PropTypes.bool.isRequired,
    style: PropTypes.object,
    testID: PropTypes.string,
    title: PropTypes.string.isRequired,
    to: PropTypes.string
  })

  render() {
    const {dataSet, primary, style, testID, to} = this.p

    const actualStyle = useMemo(() => {
      const actualStyle = [styles.button]

      if (primary) actualStyle.push(styles.buttonPrimary)
      if (style) actualStyle.push(style)

      return actualStyle
    }, [])

    if (to && Platform.OS == "web") {
      return (
        <Link to={to}>
          <View dataSet={dataSet} onClick={this.tt.onLinkClick} style={actualStyle} testID={testID}>
            {this.content()}
          </View>
        </Link>
      )
    } else {
      return (
        <Pressable dataSet={dataSet} onPress={this.tt.onPress} style={actualStyle} testID={testID}>
          {this.content()}
        </Pressable>
      )
    }
  }

  content() {
    const {primary, title} = this.p
    const textStyle = useStyles(styles, ["text", {textPrimary: primary}])

    return (
      <Text style={textStyle}>
        {title}
      </Text>
    )
  }

  onLinkClick = (e, ...args) => {
    if (this.p.disabled) {
      e.preventDefault()
    } else if (this.p.onPress) {
      this.p.onPress(e, ...args)
    }
  }

  onPress = (...args) => {
    if (this.p.disabled) {
      return
    }

    if (this.p.onPress) {
      this.p.onPress(...args)
    }

    if (this.p.to) {
      AppHistory.push(this.p.to)
    }
  }
}

export default memo(shapeComponent(ChalkyLayoutButtonUnderscore))
